import React, { useEffect, useRef, useState } from "react";
import "./modalvideoinicial.css";
import { consultarVideoOnboarding, registrarEventoVideo } from "../../services/usuarios";

export const VIDEO_ID = "KiVeOyYa6Uo";
export const VIDEO_URL = `https://www.youtube-nocookie.com/embed/${VIDEO_ID}`;
// LOCALHOST: video de bienvenida desactivado
// Poner en true antes de llevar este cambio a PRODUCTIVO.
const VIDEO_ONBOARDING_ENABLED = true;

let apiCargando = null;
export const cargarYouTubeAPI = () => {
  if (window.YT && window.YT.Player) return Promise.resolve();
  if (apiCargando) return apiCargando;

  apiCargando = new Promise((resolve) => {
    const anterior = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (anterior) anterior();
      resolve();
    };
    const script = document.createElement("script");
    script.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(script);
  });

  return apiCargando;
};

const ModalVideoInicial = () => {
  const [visible, setVisible] = useState(false);
  const yaReprodujo = useRef(false);
  const contenedorRef = useRef(null);
  const playerRef = useRef(null);

  // 1) Preguntar al backend si toca abrirlo
  useEffect(() => {
    // LOCALHOST: no consultar ni mostrar el video de bienvenida.
  if (!VIDEO_ONBOARDING_ENABLED) return;
    let cancelado = false;

    consultarVideoOnboarding(VIDEO_URL).then((mostrar) => {
      if (!cancelado && mostrar) {
        registrarEventoVideo(VIDEO_URL, "modal_abierto");
        setVisible(true);
      }
    });

    return () => { cancelado = true; };
  }, []);

  // 2) Montar el reproductor
  useEffect(() => {
    if (!visible) return;
    let destruido = false;

    cargarYouTubeAPI().then(() => {
      if (destruido || !contenedorRef.current) return;

      playerRef.current = new window.YT.Player(contenedorRef.current, {
        videoId: VIDEO_ID,
        host: "https://www.youtube-nocookie.com",
        playerVars: { rel: 0 },
        events: {
          onStateChange: (e) => {
            if (e.data === window.YT.PlayerState.PLAYING && !yaReprodujo.current) {
              yaReprodujo.current = true;
              registrarEventoVideo(VIDEO_URL, "reproducido", "modal");
            }
            if (e.data === window.YT.PlayerState.ENDED) {
              registrarEventoVideo(VIDEO_URL, "completado");
              setVisible(false);
            }
          },
        },
      });
    });

    return () => {
      destruido = true;
      if (playerRef.current && playerRef.current.destroy) {
        playerRef.current.destroy();
      }
      playerRef.current = null;
    };
  }, [visible]);

  const cerrar = () => setVisible(false);

  if (!visible) return null;

  return (
    <div className="modal-video-overlay" onClick={cerrar}>
      <div className="modal-video" onClick={(e) => e.stopPropagation()}>
        <button
          className="modal-video-cerrar"
          onClick={cerrar}
          aria-label="Cerrar"
        >
          ×
        </button>

        <h3>¡Te damos la bienvenida a Salvir!</h3>
        <p>
          En 3 minutos te mostramos cómo configurar tu cuenta,
          registrar pacientes, usar la agenda y generar recetas.
        </p>

        <div className="modal-video-wrapper">
          <div ref={contenedorRef} />
        </div>
      </div>
    </div>
  );
};

export default ModalVideoInicial;